import { Component, OnInit } from '@angular/core';
import { AnalyticLogsService } from '@services/analytic-logs/analytic-logs.service';
import { PackageService } from '@services/packages/package.service';

@Component({
  selector: 'app-barrierfree-analytics',
  templateUrl: './barrierfree-analytics.component.html',
  styleUrl: './barrierfree-analytics.component.scss',
  providers: [AnalyticLogsService, PackageService],
  standalone: false
})
export class BarrierfreeAnalyticsComponent implements OnInit {

  data: any[];
  columns = [{ prop: 'title' }, { prop: 'barrierFree' }, { prop: 'magnifyingGlass' }, { prop: 'highContrast' }];

  constructor(public logsService: AnalyticLogsService, public packageService: PackageService) {}

  async ngOnInit() {
    const byPackage = { };
    const logs = await this.logsService.find(0, 100000000, { type: 'action' });
    (logs?.data || []).forEach(log => {
      (log?.customers || []).forEach(packageId => {
        if (!byPackage[packageId]) {
          byPackage[packageId] = { magnifyingGlass: 0, barrierFree: 0, highContrast: 0 };
        }
        const key = log.message.split('helper:');
        byPackage[packageId][key[1]]++;
      });
    });
    const packageIds = Object.keys(byPackage);
    let packages = await this.fetchPackagesInBatches(packageIds);
    this.data = packages.map(p => {
      return { title: p.title, barrierFree: byPackage[p._id]['barrierFree'], magnifyingGlass: byPackage[p._id]['magnifyingGlass'], highContrast: byPackage[p._id]['highContrast'] }
    });
  }

  async fetchPackagesInBatches(packageIds: string[], batchSize: number = 50) {
    const allPackages = [];
    for (let i = 0; i < packageIds.length; i += batchSize) {
      const batchIds = packageIds.slice(i, i + batchSize);
      const batchResult = (await this.packageService.find(0, batchIds.length, { _id: { $in: batchIds } }))?.data;
      allPackages.push(...batchResult);
    }
    return allPackages;
  }

}
